module.exports = __webpack_public_path__ + "img/Leap Learning Lab MANUAL (NORSK) (10.12.19).9e2c3c07.png";